module.exports = {
	"ha": "fha",
	"id": 5.5,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2018 Q1",
		"lastYear": "2018",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 90,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by Age Category and MSM Status, Year Ending 2018 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 93.18181818181817,
						"dataLabels": {
							"enabled": false,
							"format": "41"
						},
						"color": "#043f61"
					},
					{
						"y": 81.81818181818183,
						"dataLabels": {
							"enabled": false,
							"format": "36"
						},
						"color": "#0c4250"
					},
					{
						"y": 77.27272727272727,
						"dataLabels": {
							"enabled": false,
							"format": "34"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.72727272727273,
						"dataLabels": {
							"enabled": false,
							"format": "32"
						},
						"color": "#09472e"
					},
					{
						"y": 63.63636363636363,
						"dataLabels": {
							"enabled": false,
							"format": "28"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.93877551020408,
						"dataLabels": {
							"enabled": false,
							"format": "95"
						},
						"color": "#043f61"
					},
					{
						"y": 90.81632653061224,
						"dataLabels": {
							"enabled": false,
							"format": "89"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.71428571428571,
						"dataLabels": {
							"enabled": false,
							"format": "84"
						},
						"color": "#0d4440"
					},
					{
						"y": 79.59183673469387,
						"dataLabels": {
							"enabled": false,
							"format": "78"
						},
						"color": "#09472e"
					},
					{
						"y": 70.40816326530613,
						"dataLabels": {
							"enabled": false,
							"format": "69"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.89922480620154,
						"dataLabels": {
							"enabled": false,
							"format": "125"
						},
						"color": "#043f61"
					},
					{
						"y": 89.14728682170544,
						"dataLabels": {
							"enabled": false,
							"format": "115"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.04651162790698,
						"dataLabels": {
							"enabled": false,
							"format": "111"
						},
						"color": "#0d4440"
					},
					{
						"y": 79.06976744186046,
						"dataLabels": {
							"enabled": false,
							"format": "102"
						},
						"color": "#09472e"
					},
					{
						"y": 69.76744186046511,
						"dataLabels": {
							"enabled": false,
							"format": "90"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.34905660377359,
						"dataLabels": {
							"enabled": false,
							"format": "417"
						},
						"color": "#043f61"
					},
					{
						"y": 94.81132075471697,
						"dataLabels": {
							"enabled": false,
							"format": "402"
						},
						"color": "#0c4250"
					},
					{
						"y": 90.80188679245283,
						"dataLabels": {
							"enabled": false,
							"format": "385"
						},
						"color": "#0d4440"
					},
					{
						"y": 87.5,
						"dataLabels": {
							"enabled": false,
							"format": "371"
						},
						"color": "#09472e"
					},
					{
						"y": 80.4245283018868,
						"dataLabels": {
							"enabled": false,
							"format": "341"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 93.75,
						"dataLabels": {
							"enabled": false,
							"format": "15"
						},
						"color": "#043f61"
					},
					{
						"y": 68.75,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0c4250"
					},
					{
						"y": 62.5,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0d4440"
					},
					{
						"y": 56.25,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#09472e"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.75280898876404,
						"dataLabels": {
							"enabled": false,
							"format": "87"
						},
						"color": "#043f61"
					},
					{
						"y": 94.3820224719101,
						"dataLabels": {
							"enabled": false,
							"format": "84"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.39325842696628,
						"dataLabels": {
							"enabled": false,
							"format": "76"
						},
						"color": "#0d4440"
					},
					{
						"y": 73.03370786516854,
						"dataLabels": {
							"enabled": false,
							"format": "65"
						},
						"color": "#09472e"
					},
					{
						"y": 60.67415730337079,
						"dataLabels": {
							"enabled": false,
							"format": "54"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.63779527559055,
						"dataLabels": {
							"enabled": false,
							"format": "248"
						},
						"color": "#043f61"
					},
					{
						"y": 85.8267716535433,
						"dataLabels": {
							"enabled": false,
							"format": "218"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.67716535433071,
						"dataLabels": {
							"enabled": false,
							"format": "210"
						},
						"color": "#0d4440"
					},
					{
						"y": 73.62204724409449,
						"dataLabels": {
							"enabled": false,
							"format": "187"
						},
						"color": "#09472e"
					},
					{
						"y": 57.08661417322835,
						"dataLabels": {
							"enabled": false,
							"format": "145"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.58454106280193,
						"dataLabels": {
							"enabled": false,
							"format": "404"
						},
						"color": "#043f61"
					},
					{
						"y": 88.88888888888889,
						"dataLabels": {
							"enabled": false,
							"format": "368"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.02415458937197,
						"dataLabels": {
							"enabled": false,
							"format": "352"
						},
						"color": "#0d4440"
					},
					{
						"y": 80.67632850241546,
						"dataLabels": {
							"enabled": false,
							"format": "334"
						},
						"color": "#09472e"
					},
					{
						"y": 65.94202898550725,
						"dataLabels": {
							"enabled": false,
							"format": "273"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 68.57142857142857,
						"dataLabels": {
							"enabled": false,
							"format": "48"
						},
						"color": "#043f61"
					},
					{
						"y": 55.714285714285715,
						"dataLabels": {
							"enabled": false,
							"format": "39"
						},
						"color": "#0c4250"
					},
					{
						"y": 48.57142857142857,
						"dataLabels": {
							"enabled": false,
							"format": "34"
						},
						"color": "#0d4440"
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": false,
							"format": "28"
						},
						"color": "#09472e"
					},
					{
						"y": 25.71428571428571,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.29629629629629,
						"dataLabels": {
							"enabled": false,
							"format": "104"
						},
						"color": "#043f61"
					},
					{
						"y": 87.03703703703704,
						"dataLabels": {
							"enabled": false,
							"format": "94"
						},
						"color": "#0c4250"
					},
					{
						"y": 81.48148148148148,
						"dataLabels": {
							"enabled": false,
							"format": "88"
						},
						"color": "#0d4440"
					},
					{
						"y": 68.51851851851852,
						"dataLabels": {
							"enabled": false,
							"format": "74"
						},
						"color": "#09472e"
					},
					{
						"y": 59.25925925925925,
						"dataLabels": {
							"enabled": false,
							"format": "64"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.07317073170731,
						"dataLabels": {
							"enabled": false,
							"format": "199"
						},
						"color": "#043f61"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "164"
						},
						"color": "#0c4250"
					},
					{
						"y": 76.58536585365854,
						"dataLabels": {
							"enabled": false,
							"format": "157"
						},
						"color": "#0d4440"
					},
					{
						"y": 69.26829268292683,
						"dataLabels": {
							"enabled": false,
							"format": "142"
						},
						"color": "#09472e"
					},
					{
						"y": 56.58536585365853,
						"dataLabels": {
							"enabled": false,
							"format": "116"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.43835616438356,
						"dataLabels": {
							"enabled": false,
							"format": "352"
						},
						"color": "#043f61"
					},
					{
						"y": 80.27397260273973,
						"dataLabels": {
							"enabled": false,
							"format": "293"
						},
						"color": "#0c4250"
					},
					{
						"y": 77.26027397260275,
						"dataLabels": {
							"enabled": false,
							"format": "282"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.6027397260274,
						"dataLabels": {
							"enabled": false,
							"format": "265"
						},
						"color": "#09472e"
					},
					{
						"y": 61.64383561643836,
						"dataLabels": {
							"enabled": false,
							"format": "225"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -6.818181818181824,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.195121951219512,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.555555555555558,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.882352941176472,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.0612244897959218,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.315789473684208,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.61797752808989,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.14285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.538461538461542,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.100775193798455,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.9999999999999964,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.4782608695652195,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.108108108108103,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.764705882352944,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.650943396226412,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.597122302158273,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.228855721393032,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.6363636363636376,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.086253369272233,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -6.25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.66666666666667,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.999999999999998,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.2471910112359605,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.4482758620689613,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.523809523809524,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.473684210526317,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.92307692307692,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.3622047244094446,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.096774193548388,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.669724770642202,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.952380952380958,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.459893048128343,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.4154589371980673,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.910891089108908,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.347826086956519,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.113636363636365,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.26347305389222,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -31.428571428571427,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.75,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.82051282051282,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.647058823529417,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -35.71428571428571,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.703703703703709,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.615384615384615,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.382978723404253,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.909090909090907,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.513513513513509,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.9268292682926855,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.587939698492463,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.268292682926833,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.554140127388532,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.309859154929576,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.561643835616435,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.761363636363637,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.754266211604096,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.028368794326244,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.094339622641506,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=44"
			},
			{
				"x": 9,
				"text": "30-39<br>n=98"
			},
			{
				"x": 15,
				"text": "40-49<br>n=129"
			},
			{
				"x": 21,
				"text": ">=50<br>n=424"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=16"
			},
			{
				"x": 34,
				"text": "30-39<br>n=89"
			},
			{
				"x": 40,
				"text": "40-49<br>n=254"
			},
			{
				"x": 46,
				"text": ">=50<br>n=414"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=70"
			},
			{
				"x": 59,
				"text": "30-39<br>n=108"
			},
			{
				"x": 65,
				"text": "40-49<br>n=205"
			},
			{
				"x": 71,
				"text": ">=50<br>n=365"
			}
		],
		"dataTable": {
			"MSM:<30": [
				44,
				41,
				36,
				34,
				32,
				28
			],
			"MSM:30-39": [
				98,
				95,
				89,
				84,
				78,
				69
			],
			"MSM:40-49": [
				129,
				125,
				115,
				111,
				102,
				90
			],
			"MSM:>=50": [
				424,
				417,
				402,
				385,
				371,
				341
			],
			"Non-MSM:<30": [
				16,
				15,
				11,
				10,
				9,
				8
			],
			"Non-MSM:30-39": [
				89,
				87,
				84,
				76,
				65,
				54
			],
			"Non-MSM:40-49": [
				254,
				248,
				218,
				210,
				187,
				145
			],
			"Non-MSM:>=50": [
				414,
				404,
				368,
				352,
				334,
				273
			],
			"Unknown:<30": [
				70,
				48,
				39,
				34,
				28,
				18
			],
			"Unknown:30-39": [
				108,
				104,
				94,
				88,
				74,
				64
			],
			"Unknown:40-49": [
				205,
				199,
				164,
				157,
				142,
				116
			],
			"Unknown:>=50": [
				365,
				352,
				293,
				282,
				265,
				225
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_fha_5_5.json
// module id = 201
// module chunks = 0